import React, { Component, useContext } from "react";
import CartContext from "./CartContext";
import { LoadSpinner } from "./LoadSpinner";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import { FaTrashAlt } from "react-icons/fa";
import { BsBoxArrowUpRight, BsTrash } from "react-icons/bs";
import { BiBarChart } from "react-icons/bi";
import { FaWhatsapp } from "react-icons/fa";
import {
  InputGroup,
  OverlayTrigger,
  Badge,
  Tooltip,
  Tabs,
  Tab,
  Stack,
  FormControl,
  Button,
  ButtonToolbar,
  Modal,
  Form,
  Row,
  Col,
  FloatingLabel,
  Nav,
  Table,
  Navbar,
  Card,
} from "react-bootstrap";
import DatePicker from "react-date-picker";

import { Pie, Line, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
} from "chart.js";

ChartJS.register(
  ArcElement,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
);

// ---------------------------
// QuotationRequest (TOP VIEW)
// ---------------------------
export class QuotationRequest extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      ordersDetail: [],
      selectedOrder: -1,
      selectedOrderRow: "",
      filteredOrdersDetail: [],
      showOrderDetailsModal: false,
      loadSpinnerOpen: false,
      firstload: false,
      quotationTypes: [],
      refreshTab: false,
      ShowNewRequestTabRefresh: true,
      ShowQuotationTabRefresh: false,
      ShowPaymentTabRefresh: false,
      ShowProduceTabRefresh: false,
      ShowShipTabRefresh: false,
      ShowDeliveryTabRefresh: false,
      ShowHistoryTabRefresh: false,
      key: "NewRequest",
      users: [],
      showDashboard: false,
    };
  }

  GetQuoteStatusTypes = () => {
    fetch(process.env.REACT_APP_API + "Quotation/GetQuoteStatusTypes/")
      .then((response) => response.json())
      .then((data) => {
        this.setState({ quotationTypes: data });
      })
      .catch((error) => {});
  };
  GetUsers = () => {
    const config = {
      headers: { Authorization: `Bearer ${this.context.userData.bearertoken}` },
    };
    fetch(
      process.env.REACT_APP_API +
        "AdminUsers/GetStoreUserAccounts/" +
        this.context.storeId,
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({ users: data });
      })
      .catch((error) => {
        alert("Session Timeout! Signout and Signin again!");
      });
  };

  // factory for a brand-new quote (client-side placeholder)
  getNewQuoteTemplate = () => ({
    // leave id undefined -> create mode
    id: undefined,
    storeId: this.context.storeId,
    quoteNumber: "",
    customerName: "",
    contactNumber: "",
    emailId: "",
    purposeOfProcurement: "",
    preferredLanguage: "",
    deliveryTimeline: "",
    assignedTo: "",
    requestSeverityType: "",
    quotationAttachmentFile: "",
    amountReceived: 0,
    quoteStatus: 1, // NewRequest
    paymentStatus: 2, // UnPaid
    notes: "",
    cstomerFeedback: "",
    created: new Date().toISOString(),
    modified: new Date().toISOString(),
    taxNo: "",
    attachmentFileName: "",
    invoiceFileName: "",
    address: "",
    landmark: "",
    city: "",
    pincode: "",
    state: "",
    country: "",
    taxPercentage: 18,
    quoteItems: [],
    quotePayments: [],
  });

  openNewRequest = () => {
    const fresh = this.getNewQuoteTemplate();
    this.setState({
      selectedOrder: fresh,
      showOrderDetailsModal: true,
      key: "NewRequest",
    });
    this.ShowSelectedTab("NewRequest");
  };

  refreshTab = () => {
    this.setState({ refreshTab: true }, () => {
      this.setState({ refreshTab: false });
    });
  };

  ShowSelectedTab = (k) => {
    this.setState({
      ShowNewRequestTabRefresh: false,
      ShowQuotationTabRefresh: false,
      ShowPaymentTabRefresh: false,
      ShowProduceTabRefresh: false,
      ShowShipTabRefresh: false,
      ShowDeliveryTabRefresh: false,
      ShowHistoryTabRefresh: false,
    });

    if (k == "NewRequest") this.setState({ ShowNewRequestTabRefresh: true });
    if (k == "Quotation") this.setState({ ShowQuotationTabRefresh: true });
    if (k == "Payment") this.setState({ ShowPaymentTabRefresh: true });
    if (k == "Produce") this.setState({ ShowProduceTabRefresh: true });
    if (k == "Ship") this.setState({ ShowShipTabRefresh: true });
    if (k == "Delivery") this.setState({ ShowDeliveryTabRefresh: true });
    if (k == "History") this.setState({ ShowHistoryTabRefresh: true });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.GetUsers();
    this.GetQuoteStatusTypes();
  }
  handleSaved = () => {
    // reload the list in this tab
    this.refreshTab();
    // refresh the top counters (if available from context)
    this.context.GetOrdersSummary && this.context.GetOrdersSummary();
  };

  render() {
    return (
      <>
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        {this.state.showDashboard && (
          <QuotationDashboardModal
            show={this.state.showDashboard}
            onHide={() => this.setState({ showDashboard: false })}
          />
        )}
        <div className="px-0 bg-white">
          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h3 className=""> Quotation Management</h3>

            <Navbar.Collapse className="justify-content-end m-0 p-0 ">
              <Nav>
                <ButtonToolbar className="text-start align-middle">
                  <Button
                    className="mainthemecolor"
                    onClick={this.openNewRequest}
                  >
                    + Add
                  </Button>
                  &nbsp;
                  <Button
                    className="mainthemecolor"
                    onClick={() => this.refreshTab()}
                  >
                    Refresh
                  </Button>
                  &nbsp;
                  <Button
                    variant="outline-primary"
                    onClick={() => this.setState({ showDashboard: true })}
                  >
                    <BiBarChart size={18} /> Analytics
                  </Button>
                  &nbsp;&nbsp;
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          {this.state.refreshTab == false ? (
            <>
              {this.context.store.businessTypeId ==
                this.context.BusinessTypes.STEELTRADERS ||
              this.context.storeSettings.isQuotationSupported == false ? (
                <>
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={(k) => {
                      this.setState({ key: k });
                      this.ShowSelectedTab(k);
                    }}
                    className="mb-3 bg-light fw-bold"
                    fill
                    style={{ fontSize: "16px", color: "yellow" }}
                  >
                    <Tab
                      eventKey="NewRequest"
                      title={
                        "1.New (" +
                        this.context.orderSummary.quotesNewRequestCount +
                        ")"
                      }
                    >
                      {this.state.ShowNewRequestTabRefresh == true ? (
                        <QuotationRequestTable
                          CurrentState="NewRequest"
                          users={this.state.users}
                        ></QuotationRequestTable>
                      ) : null}
                    </Tab>
                    <Tab
                      eventKey="Quotation"
                      title={
                        "2.In-Progress (" +
                        this.context.orderSummary.quotesReviewCount +
                        ")"
                      }
                    >
                      {this.state.ShowQuotationTabRefresh == true ? (
                        <QuotationRequestTable
                          CurrentState="Quotation"
                          users={this.state.users}
                        ></QuotationRequestTable>
                      ) : null}
                    </Tab>
                    <Tab
                      eventKey="History"
                      title={
                        "3.Complete (" +
                        this.context.orderSummary.quotesClosedCount +
                        ")"
                      }
                    >
                      {this.state.ShowHistoryTabRefresh == true ? (
                        <QuotationRequestTable
                          CurrentState="History"
                          users={this.state.users}
                        ></QuotationRequestTable>
                      ) : null}
                    </Tab>
                  </Tabs>
                </>
              ) : (
                <>
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={(k) => {
                      this.setState({ key: k });
                      this.ShowSelectedTab(k);
                    }}
                    className="mb-3 bg-light fw-bold"
                    fill
                    style={{ fontSize: "16px", color: "yellow" }}
                  >
                    <Tab
                      eventKey="NewRequest"
                      title={
                        "1.New (" +
                        this.context.orderSummary.quotesNewRequestCount +
                        ")"
                      }
                    >
                      {this.state.ShowNewRequestTabRefresh == true ? (
                        <QuotationRequestTable
                          CurrentState="NewRequest"
                          users={this.state.users}
                        ></QuotationRequestTable>
                      ) : null}
                    </Tab>
                    <Tab
                      eventKey="Quotation"
                      title={
                        "2.Quotation (" +
                        this.context.orderSummary.quotesReviewCount +
                        ")"
                      }
                    >
                      {this.state.ShowQuotationTabRefresh == true ? (
                        <QuotationRequestTable
                          CurrentState="Quotation"
                          users={this.state.users}
                        ></QuotationRequestTable>
                      ) : null}
                    </Tab>

                    <Tab
                      eventKey="Payment"
                      title={
                        "3.Payment (" +
                        this.context.orderSummary.quotesPaymentCount +
                        ")"
                      }
                    >
                      {this.state.ShowPaymentTabRefresh == true ? (
                        <QuotationRequestTable
                          CurrentState="Payment"
                          users={this.state.users}
                        ></QuotationRequestTable>
                      ) : null}
                    </Tab>
                    <Tab
                      eventKey="Produce"
                      title={
                        "4.Produce (" +
                        this.context.orderSummary.quotesProduceCount +
                        ")"
                      }
                    >
                      {this.state.ShowProduceTabRefresh == true ? (
                        <QuotationRequestTable
                          CurrentState="Produce"
                          users={this.state.users}
                        ></QuotationRequestTable>
                      ) : null}
                    </Tab>
                    <Tab
                      eventKey="Ship"
                      title={
                        "5.Ship (" +
                        this.context.orderSummary.quotesShipCount +
                        ")"
                      }
                    >
                      {this.state.ShowShipTabRefresh == true ? (
                        <QuotationRequestTable
                          CurrentState="Ship"
                          users={this.state.users}
                        ></QuotationRequestTable>
                      ) : null}
                    </Tab>
                    <Tab
                      eventKey="Delivery"
                      title={
                        "6.Delivery (" +
                        this.context.orderSummary.quotesDeliveryCount +
                        ")"
                      }
                    >
                      {this.state.ShowDeliveryTabRefresh == true ? (
                        <QuotationRequestTable
                          CurrentState="Delivery"
                          users={this.state.users}
                        ></QuotationRequestTable>
                      ) : null}
                    </Tab>

                    <Tab
                      eventKey="History"
                      title={
                        "7.History (" +
                        this.context.orderSummary.quotesClosedCount +
                        ")"
                      }
                    >
                      {this.state.ShowHistoryTabRefresh == true ? (
                        <QuotationRequestTable
                          CurrentState="History"
                          users={this.state.users}
                        ></QuotationRequestTable>
                      ) : null}
                    </Tab>
                  </Tabs>
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </div>

        {/* When opening brand-new OR existing */}
        {this.state.showOrderDetailsModal === true ? (
          <>
            {window.innerWidth >= 900 ? (
              <QuotationRequestDetails
                show={this.state.showOrderDetailsModal}
                onHide={() => this.setState({ showOrderDetailsModal: false })}
                orderDetail={this.state.selectedOrder}
                quotationTypes={this.state.quotationTypes}
                CurrentState={this.state.key}
                users={this.state.users}
                onSaved={this.handleSaved}
              />
            ) : (
              <QuotationRequestDetails
                show={this.state.showOrderDetailsModal}
                onHide={() => this.setState({ showOrderDetailsModal: false })}
                orderDetail={this.state.selectedOrder}
                quotationTypes={this.state.quotationTypes}
                users={this.state.users}
                onSaved={this.handleSaved}
              />
            )}
          </>
        ) : null}
      </>
    );
  }
}

// Replace your existing QuotationRequestTable with this
export class QuotationRequestTable extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      ordersDetail: [],
      selectedOrder: -1,
      filteredOrdersDetail: [],
      showOrderDetailsModal: false,
      loadSpinnerOpen: false,
      firstload: false,
      quotationTypes: [],
      searchquery: "",
      isMobile: false,
    };
    this._isMounted = false;
  }

  checkMobile = () => {
    const mq = window.matchMedia("(max-width: 767px)");
    this.setState({ isMobile: mq.matches });
  };
  exportToCSV = () => {
    const rows = this.state.filteredOrdersDetail || [];
    if (!rows.length) {
      alert("No data to export");
      return;
    }

    // Define CSV headers
    const headers = [
      "Quote Number",
      "Customer Name",
      "Contact Number",
      "Email",
      "Purpose",
      "Language",
      "Timeline",
      "Status",
      "Importance",
      "Grand Total",
      "Total Paid",
      "Payment Status",
      "Assigned To",
      "Created",
    ];

    // Build CSV rows
    const csvRows = [headers.join(",")];

    rows.forEach((order) => {
      const items = order?.quoteItems || [];
      const pays = order?.quotePayments || [];

      const subtotal = items.reduce(
        (a, v) => a + Number(v?.quoteAmount || 0),
        0,
      );
      const tax = subtotal * 0.18;
      const grand = subtotal + tax;
      const paid = pays.reduce((a, v) => a + Number(v?.amount || 0), 0);

      const severity =
        order.requestSeverityType === 1
          ? "HOT"
          : order.requestSeverityType === 2
            ? "WARM"
            : order.requestSeverityType === 3
              ? "COLD"
              : "";

      const paymentText =
        order.paymentStatus === 1
          ? "Paid"
          : order.paymentStatus === 2
            ? "UnPaid"
            : order.paymentStatus === 3
              ? "PartiallyPaid"
              : "";

      const row = [
        `"${order.quoteNumber}"`,
        `"${order.customerName}"`,
        `"${order.contactNumber}"`,
        `"${order.emailId}"`,
        `"${order.purposeOfProcurement || ""}"`,
        `"${order.preferredLanguage || ""}"`,
        `"${order.deliveryTimeline || ""}"`,
        `"${this.GetStatusName(order.quoteStatus)}"`,
        `"${severity}"`,
        `"${grand}"`,
        `"${paid}"`,
        `"${paymentText}"`,
        `"${this.GetUserID(order.assignedTo) || "-"}"`,
        `"${this.context.GetInDateFormat(new Date(order.created))}"`,
      ];

      csvRows.push(row.join(","));
    });

    // Build blob
    const csvData = csvRows.join("\n");
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    // Download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "QuotationRequests.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  handleSaved = () => {
    // reload the list in this tab
    this.Reload();
    // refresh the top counters (if available from context)
    this.context.GetOrdersSummary && this.context.GetOrdersSummary();
  };

  GetQuoteStatusTypes = () => {
    fetch(process.env.REACT_APP_API + "Quotation/GetQuoteStatusTypes/")
      .then((response) => response.json())
      .then((data) => {
        this.setState({ quotationTypes: data });
      })
      .catch((error) => {});
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  Reload = () => {
    this.GetOrders();
  };

  GetStatusName = (id) => {
    var result = this.state.quotationTypes.filter((f) => f.id == id);
    if (result.length > 0) return result[0].statusName;
    return "";
    // you had it as text case earlier—keeping same
  };

  GetOrders = () => {
    this.setState({ ordersDetail: [] }, () => {
      this.ShowLoadSpinner();
      fetch(
        process.env.REACT_APP_API +
          "Quotation/GetQuotationRequestsByState/" +
          this.context.storeId +
          "/" +
          this.props.CurrentState,
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            this.context.userData.roleId ==
            this.context.UserRoles.QUOTATIONEMPLOYEE
          ) {
            this.setState({
              ordersDetail: data.filter(
                (f) => f.assignedTo == this.context.userData.id,
              ),
              filteredOrdersDetail: data.filter(
                (f) => f.assignedTo == this.context.userData.id,
              ),
            });
          } else {
            this.setState({ ordersDetail: data, filteredOrdersDetail: data });
          }
          this.HideLoadSpinner();
        })
        .catch((error) => {
          this.HideLoadSpinner();
        });
    });
  };

  OnOrderRowClick = (e, order) => {
    this.setState({ selectedOrder: order, showOrderDetailsModal: true });
  };
  ModalClose = () => {
    this.setState({ showOrderDetailsModal: false }, () => {});
    this.Reload();
  };

  onSearchChange = (query) => {
    this.setState({ reload: false, searchquery: query });
    if (!query) {
      this.setState({ filteredOrdersDetail: this.state.ordersDetail }, () =>
        this.setState({ reload: true }),
      );
      return;
    }
    const fuse = new Fuse(this.state.ordersDetail, {
      keys: ["quoteNumber", "deliveryAddress", "customerName", "contactNumber"],
      threshold: 0.0,
      ignoreLocation: true,
      findAllMatches: true,
      includeMatches: true,
      distance: 120,
    });
    const result = fuse.search(query);
    const finalResult = [];
    if (result.length) {
      result.forEach((item) => finalResult.push(item.item));
      this.setState({ filteredOrdersDetail: finalResult.slice(0, 15) }, () =>
        this.setState({ reload: true }),
      );
    } else {
      this.setState({ filteredOrdersDetail: [] });
    }
  };

  hideDeleteButtonMenu = () => {
    if (this.context.UserRoles.PRODUCTADMIN == this.context.userData.roleId) {
      return false;
    } else {
      return true;
    }
  };

  OnDeleteOrder = (e, order) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "Quotation/DeleteAnQuotationRequest/" +
        order.id,
      requestOptions,
    )
      .then((res) => {
        if (res.status != 200) {
          this.Reload();
          alert("not deleted");
          return;
        }
        this.Reload();
        Swal.fire({
          title: "Status",
          text: "Deleted Successfully",
          timer: 1000,
        });
      })
      .catch((error) => {
        alert("OnDelete Failed" + error);
      });
  };

  GetDateDifference = (createddate) => {
    var startTime = new Date();
    var endTime = new Date(createddate);
    var diff = startTime - endTime;
    var minutes = Math.floor(diff / 1000 / 60);
    var hours = Math.floor(minutes / 60, 0);
    var days = Math.floor(hours / 24, 0);
    var daysstring = days > 0 ? days + "d : " : " ";
    var hoursstring = hours > 0 ? (hours % 24) + "h : " : " ";

    return daysstring + hoursstring + (minutes % 60) + " m";
  };

  GetUserID = (id) => {
    var result = this.props.users?.filter((d) => d.id == id);
    if (result?.length > 0) return result[0].emailId;
    return "";
  };

  componentDidMount() {
    this._isMounted = true;
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    window.scrollTo(0, 0);

    if (this.state.firstload == false) {
      this.state.firstload = true;
      this.GetOrders();
      this.GetQuoteStatusTypes();
    }
  }
  sanitizePhoneNumber(phone) {
    if (!phone) return "";
    const digits = String(phone).replace(/\D/g, "");
    // remove any leading zeros
    return digits.replace(/^0+/, "");
  }

  // return string suitable for wa.me (prefix with country code when needed)
  getWhatsAppNumber(phone) {
    const digits = this.sanitizePhoneNumber(phone);
    if (!digits) return null;

    // If digits already look like they include country code (length > 10), return as-is
    if (digits.length > 10) return digits;

    // if 10 digits, prepend country code - use store countryCode if present, fallback to 91
    const cc = (this.context?.store?.countryCode || "91")
      .toString()
      .replace(/\D/g, "");
    return `${cc}${digits}`;
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener("resize", this.checkMobile);
  }

  renderTable = () => {
    return (
      <div className="table-responsive">
        <Table
          striped
          hover
          bordered
          className="align-middle text-start mb-0 quo-table"
        >
          <thead className="sticky-thead">
            <tr style={{ fontSize: "12px" }}>
              <th width="1%" className="text-center">
                #
              </th>
              <th width="10%" className="text-center">
                Received
              </th>
              <th width="12%" className="text-center">
                Quotation No
              </th>
              <th width="22%" className="text-center">
                Customer
              </th>
              <th width="15%" className="text-center">
                Purpose
              </th>
              <th width="15%" className="text-center">
                Status
              </th>
              <th width="15%" className="text-center">
                Quote & Payment
              </th>
              <th width="10%" className="text-center">
                Options
              </th>
            </tr>
          </thead>

          <tbody className="text-center" style={{ fontSize: "14px" }}>
            {(this.state.filteredOrdersDetail || [])
              .sort((a, b) => (a.created > b.created ? 1 : -1))
              .map((order, i) => {
                const items = order?.quoteItems || [];
                const pays = order?.quotePayments || [];

                const subtotal = items.reduce(
                  (a, v) => a + Number(v?.quoteAmount || 0),
                  0,
                );
                const tax = subtotal * 0.18;
                const grand = subtotal + tax;
                const paid = pays.reduce(
                  (a, v) => a + Number(v?.amount || 0),
                  0,
                );

                const severity =
                  order.requestSeverityType === 1
                    ? "HOT"
                    : order.requestSeverityType === 2
                      ? "WARM"
                      : order.requestSeverityType === 3
                        ? "COLD"
                        : "";

                const paymentText =
                  order.paymentStatus === 1
                    ? "Paid"
                    : order.paymentStatus === 2
                      ? "UnPaid"
                      : order.paymentStatus === 3
                        ? "PartiallyPaid"
                        : "";

                const paymentBadge =
                  order.paymentStatus === 1
                    ? "success"
                    : order.paymentStatus === 3
                      ? "warning"
                      : "secondary";

                const severityBadge =
                  severity === "HOT"
                    ? "danger"
                    : severity === "WARM"
                      ? "warning"
                      : severity === "COLD"
                        ? "info"
                        : "secondary";

                return (
                  <tr
                    key={order.id}
                    className="quo-row"
                    onDoubleClick={(e) => this.OnOrderRowClick(e, order)}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="text-center">{i + 1}</td>

                    <td className="text-center">
                      {this.context.GetInDateFormat(new Date(order.created))}
                    </td>

                    <td className="text-start">
                      <div className="d-flex flex-column gap-1">
                        <div className="fw-bold fs-5">{order.quoteNumber}</div>
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <small className="text-muted">Assigned To</small>
                          <span className="badge text-bg-light border text-dark">
                            {this.GetUserID(order.assignedTo) || "-"}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td className="text-start">
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex justify-content-between">
                          <small className="text-muted">Name</small>
                          <span className="fw-semibold">
                            {order.customerName}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between">
                          <small className="text-muted">Contact</small>
                          <span className="fw-semibold">
                            {/* {order.contactNumber} */}

                            {order.contactNumber || "—"}

                            {/* whatsapp link */}
                            {(() => {
                              const waNum = this.getWhatsAppNumber(
                                order.contactNumber,
                              );
                              if (!waNum) return null;
                              const waUrl = `https://wa.me/${waNum}`;

                              return (
                                <OverlayTrigger
                                  overlay={<Tooltip>Open WhatsApp</Tooltip>}
                                >
                                  <a
                                    href={waUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="ms-2"
                                    style={{ textDecoration: "none" }}
                                    title={`WhatsApp ${order.contactNumber}`}
                                  >
                                    <FaWhatsapp
                                      size={18}
                                      style={{
                                        color: "#25D366",
                                        verticalAlign: "middle",
                                      }}
                                    />
                                  </a>
                                </OverlayTrigger>
                              );
                            })()}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between">
                          <small className="text-muted">Email</small>
                          <span className="text-truncate">{order.emailId}</span>
                        </div>
                      </div>
                    </td>

                    <td className="text-start">
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex justify-content-between">
                          <small className="text-muted">Purpose</small>
                          <span className="badge bg-info text-dark truncate-200">
                            {order.purposeOfProcurement || "-"}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between">
                          <small className="text-muted">Language</small>
                          <span className="badge bg-secondary">
                            {order.preferredLanguage || "-"}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between">
                          <small className="text-muted">Timeline</small>
                          <span className="badge bg-dark">
                            {order.deliveryTimeline || "-"}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex justify-content-between">
                          <small className="text-muted">Status</small>
                          <span className="badge text-bg-warning text-dark">
                            {this.GetStatusName(order.quoteStatus)}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between">
                          <small className="text-muted">Importance</small>
                          <span
                            className={
                              severityBadge === "warning" ||
                              severityBadge === "info"
                                ? `badge text-bg-${severityBadge} text-dark border`
                                : `badge text-bg-${severityBadge} border text-dark`
                            }
                          >
                            {severity || "-"}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="text-start">
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex justify-content-between">
                          <small className="text-muted">Grand Total</small>
                          <span className="fw-bold text-primary fs-6">
                            {Number(grand).toLocaleString(
                              this.context.storeSettings.defaultLocale,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                                style: "currency",
                                currency:
                                  this.context.storeSettings.defaultCurrency,
                              },
                            )}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between">
                          <small className="text-muted">Total Paid</small>
                          <span className="fw-bold text-success fs-6">
                            {Number(paid).toLocaleString(
                              this.context.storeSettings.defaultLocale,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                                style: "currency",
                                currency:
                                  this.context.storeSettings.defaultCurrency,
                              },
                            )}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between">
                          <small className="text-muted">Payment</small>
                          <span className={`badge bg-${paymentBadge}`}>
                            {paymentText}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td className="text-center">
                      <div className="d-flex justify-content-between">
                        <OverlayTrigger overlay={<Tooltip>Open Order</Tooltip>}>
                          <Button
                            className="px-2"
                            onClick={(e) => this.OnOrderRowClick(e, order)}
                          >
                            <BsBoxArrowUpRight /> Open
                          </Button>
                        </OverlayTrigger>

                        <OverlayTrigger
                          overlay={<Tooltip>Delete Order</Tooltip>}
                        >
                          <Button
                            variant="danger"
                            className="px-2"
                            hidden={this.hideDeleteButtonMenu()}
                            onClick={(e) => {
                              if (
                                window.confirm(
                                  "Are you sure that you want to Delete?",
                                )
                              ) {
                                this.OnDeleteOrder(e, order);
                              }
                            }}
                          >
                            <BsTrash />
                          </Button>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
    );
  };

  // Mobile cards rendering (compact, 3 logical columns)
  renderCards = () => {
    const rows = (this.state.filteredOrdersDetail || []).sort((a, b) =>
      a.created > b.created ? 1 : -1,
    );

    return (
      <div className="row g-2">
        {rows.map((order, idx) => {
          const items = order?.quoteItems || [];
          const pays = order?.quotePayments || [];
          const subtotal = items.reduce(
            (a, v) => a + Number(v?.quoteAmount || 0),
            0,
          );
          const tax = subtotal * 0.18;
          const grand = subtotal + tax;
          const paid = pays.reduce((a, v) => a + Number(v?.amount || 0), 0);
          const severity =
            order.requestSeverityType === 1
              ? "HOT"
              : order.requestSeverityType === 2
                ? "WARM"
                : order.requestSeverityType === 3
                  ? "COLD"
                  : "";
          const paymentText =
            order.paymentStatus === 1
              ? "Paid"
              : order.paymentStatus === 2
                ? "UnPaid"
                : order.paymentStatus === 3
                  ? "PartiallyPaid"
                  : "";

          return (
            <div className="col-12" key={order.id || idx}>
              <div className="card shadow-sm">
                <div className="card-body p-2">
                  <div className="d-flex align-items-start">
                    {/* Left: main info (wide) */}
                    <div className="flex-grow-1">
                      <div className="fw-bold">{order.quoteNumber}</div>
                      <div className="small text-muted">
                        {this.context.GetInDateFormat(new Date(order.created))}
                      </div>
                      <div className="small mt-1">{order.customerName}</div>
                      <div className="small text-truncate">
                        {order.contactNumber} • {order.emailId}
                      </div>
                    </div>

                    {/* Center: meta */}
                    <div className="px-2 text-center" style={{ minWidth: 110 }}>
                      <div className="small text-muted">Total</div>
                      <div className="fw-bold">
                        {Number(grand).toLocaleString(
                          this.context.storeSettings.defaultLocale,
                          {
                            style: "currency",
                            currency:
                              this.context.storeSettings.defaultCurrency,
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          },
                        )}
                      </div>
                      <div className="small text-muted mt-1">{paymentText}</div>
                      <div className="small mt-1">
                        <span className="badge bg-secondary">
                          {severity || "-"}
                        </span>
                      </div>
                    </div>

                    {/* Right: actions */}
                    <div className="d-flex flex-column align-items-end gap-1">
                      <Button
                        size="sm"
                        className="mb-1"
                        onClick={(e) => this.OnOrderRowClick(e, order)}
                      >
                        <BsBoxArrowUpRight /> Open
                      </Button>
                      <Button
                        size="sm"
                        variant="danger"
                        hidden={this.hideDeleteButtonMenu()}
                        onClick={(e) => {
                          if (
                            window.confirm(
                              "Are you sure that you want to Delete?",
                            )
                          ) {
                            this.OnDeleteOrder(e, order);
                          }
                        }}
                      >
                        <BsTrash />
                      </Button>
                    </div>
                  </div>

                  {/* Purpose / assigned */}
                  <div className="d-flex justify-content-between mt-2 small text-muted">
                    <div className="text-truncate" style={{ maxWidth: "65%" }}>
                      <strong>Purpose:</strong>{" "}
                      {order.purposeOfProcurement || "-"}
                    </div>
                    <div>
                      <small>Assigned</small>
                      <div className="small">
                        {this.GetUserID(order.assignedTo) || "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const { loadSpinnerOpen, showOrderDetailsModal } = this.state;

    return (
      <>
        {loadSpinnerOpen && <LoadSpinner open="true" />}
        <div>
          <Stack direction="horizontal" gap={3} className="py-4 mx-1 bg-light">
            <b>{/* search icon */}</b>
            <FormControl
              type="search"
              placeholder="Search by QuotationId / Phoneno / CustomerName... "
              className="text-primary fw-bold bg-white "
              aria-label="Search"
              style={{ fontSize: "18px" }}
              onChange={(e) => this.onSearchChange(e.target.value)}
            />
            <Button
              variant="outline-success"
              className="ms-2"
              onClick={this.exportToCSV}
            >
              Export CSV
            </Button>
          </Stack>

          <div className="p-2 bg-white rounded shadow-sm">
            {this.state.isMobile ? this.renderCards() : this.renderTable()}
          </div>

          {showOrderDetailsModal && (
            <QuotationRequestDetails
              show={true}
              onHide={() => this.setState({ showOrderDetailsModal: false })}
              orderDetail={this.state.selectedOrder}
              quotationTypes={this.state.quotationTypes}
              CurrentState={this.props.CurrentState}
              users={this.props.users}
              onSaved={this.handleSaved}
            />
          )}
        </div>
      </>
    );
  }
}

// Replace your existing QuotationRequestDetails with this (responsive modal)
export class QuotationRequestDetails extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    const od = {
      quoteItems: [],
      quotePayments: [],
      loadingCharges: 0,
      transportationCharges: 0,
      taxPercentage: 18,
      ...props.orderDetail,
    };

    od.loadingCharges = Number(od.loadingCharges || 0);
    od.transportationCharges = Number(od.transportationCharges || 0);
    od.taxPercentage = Number(od.taxPercentage ?? 18);
    od.quoteItems = od.quoteItems || [];
    od.quotePayments = od.quotePayments || [];

    this.state = {
      loadSpinnerOpen: false,
      showProductModal: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      orderDetail: od,
      quoteStatusNew: "",
      ShowPaymentModal: false,
      ShowNewRequirementModal: false,
      reloaded: false,
      users: this.props.users || [],
      editingRowBackup: null,
      newRequirement: {
        productName: "",
        costPerPiece: 0,
        qty: 1,
        thickness: "",
        width: "",
        length: "",
        pieces: "",
      },
      showInlineAdd: false,
    };

    this.printInvoice = this.printInvoice.bind(this);
  }

  addProductToQuotation = (product) => {
    this.setState((prev) => {
      const orderDetail = { ...prev.orderDetail };
      const items = [...(orderDetail.quoteItems || [])];

      const sellingPrice = (product.mrp || 0) - (product.discount || 0);

      items.push({
        productId: product.id,
        productName: product.name,
        sku: product.sku,
        qty: 1,
        costPerPiece: sellingPrice,
        quoteAmount: sellingPrice,
        gst: product.gst || 0,
        unit: product.unit || "",
        seqNo: items.length + 1,
        __isEditing: true,
      });

      orderDetail.quoteItems = items;

      return {
        orderDetail,
        showProductModal: false,
      };
    });
  };

  printInvoice() {
    try {
      // build same URL you use for download (keep identical logic so it targets same file)
      const url =
        this.context.store.storageBlobUrl +
        this.context.store.storageBlobContainerName +
        "/invoice/" +
        this.state.orderDetail.quoteNumber +
        ".html" +
        this.context.store.storageSasToken +
        "&xyz=" +
        new Date().toLocaleString();

      // attempt to fetch the invoice HTML and print it from a new window
      fetch(url, { cache: "no-store" })
        .then((res) => {
          if (!res.ok) throw new Error("Fetch failed");
          return res.text();
        })
        .then((html) => {
          // open a new blank window and write HTML into it so we control printing
          const w = window.open("", "_blank");
          if (!w) {
            // popup blocked — fallback to opening the URL directly
            window.open(url, "_blank");
            return;
          }

          // write content and ensure print AFTER load
          w.document.open();
          w.document.write(html);
          w.document.close();

          // Some invoices may rely on external resources; wait a bit then print
          const tryPrint = () => {
            try {
              w.focus();
              w.print();
              // optionally close after printing; comment out if you want user to see it
              // w.close();
            } catch (err) {
              // ignore; could be cross-origin or blocking; fallback to opening direct URL
              console.warn(
                "Auto print failed, opened invoice for manual printing",
                err,
              );
            }
          };

          // If the invoice HTML includes scripts/styles that take time, give it a short delay
          // Adjust timeout if needed
          setTimeout(tryPrint, 600);
        })
        .catch((err) => {
          console.warn(
            "Could not fetch invoice HTML — opening direct URL",
            err,
          );
          // fallback: open the raw URL for manual print
          const fallback =
            this.context.store.storageBlobUrl +
            this.context.store.storageBlobContainerName +
            "/invoice/" +
            this.state.orderDetail.quoteNumber +
            ".html" +
            this.context.store.storageSasToken +
            "&xyz=" +
            new Date().toLocaleString();
          window.open(fallback, "_blank");
        });
    } catch (e) {
      console.error(e);
      // final fallback
      const fallback =
        this.context.store.storageBlobUrl +
        this.context.store.storageBlobContainerName +
        "/invoice/" +
        this.state.orderDetail.quoteNumber +
        ".html" +
        this.context.store.storageSasToken +
        "&xyz=" +
        new Date().toLocaleString();
      window.open(fallback, "_blank");
    }
  }

  // add an empty editable row (used by +Add)
  addEmptyRow = () => {
    this.setState(
      (prev) => {
        const orderDetail = { ...prev.orderDetail };
        const items = [...(orderDetail.quoteItems || [])];
        const seqNo = items.length + 1;

        const empty = this.context.isSteelTraders()
          ? {
              productName: "",
              thickness: "",
              width: "",
              length: "",
              pieces: "",
              qty: 0,
              costPerPiece: 0,
              quoteAmount: 0,
              seqNo,
              __isNew: true,
              __isEditing: true,
            }
          : this.context.storeSettings.isQuotationSupported
            ? {
                categoryName: "",
                productName: "",
                detailedRequirement: "",
                qty: 0,
                costPerPiece: 0,
                quoteAmount: 0,
                seqNo,
                __isNew: true,
                __isEditing: true,
              }
            : {
                productName: "",
                qty: 0,
                costPerPiece: 0,
                quoteAmount: 0,
                seqNo,
                __isNew: true,
                __isEditing: true,
              };
        items.push(empty);
        orderDetail.quoteItems = items;
        return { orderDetail };
      },
      () => {
        // optionally focus the last row input — left out for minimal change
      },
    );
  };

  // toggle edit mode for a row; when starting edit, backup original row under state.editingRowBackup
  toggleEditRow = (index, startEdit) => {
    this.setState((prev) => {
      const orderDetail = { ...prev.orderDetail };
      const items = [...(orderDetail.quoteItems || [])];
      if (!items[index]) return null;

      if (startEdit) {
        // store a shallow copy to allow cancel
        return {
          orderDetail: {
            ...orderDetail,
            quoteItems: items.map((it, i) =>
              i === index ? { ...it, __isEditing: true } : it,
            ),
          },
          editingRowBackup: { index, backup: { ...items[index] } },
        };
      } else {
        // stop editing (save will already have updated the item)
        items[index] = { ...items[index], __isEditing: false, __isNew: false };
        orderDetail.quoteItems = items;
        return { orderDetail, editingRowBackup: null };
      }
    });
  };

  // cancel edit for a row: restore backup if exists, or delete if it was a new empty row
  cancelEditRow = (index) => {
    this.setState((prev) => {
      const orderDetail = { ...prev.orderDetail };
      const items = [...(orderDetail.quoteItems || [])];
      const backupObj = prev.editingRowBackup;
      if (backupObj && backupObj.index === index) {
        // restore
        items[index] = { ...backupObj.backup, __isEditing: false };
        orderDetail.quoteItems = items;
        return { orderDetail, editingRowBackup: null };
      } else {
        // if no backup, and row was new, remove it
        if (items[index]?.__isNew) items.splice(index, 1);
        orderDetail.quoteItems = items;
        return { orderDetail, editingRowBackup: null };
      }
    });
  };

  // Save row: recompute quoteAmount, mark not editing
  saveRow = (index) => {
    this.setState((prev) => {
      const orderDetail = { ...prev.orderDetail };
      const items = [...(orderDetail.quoteItems || [])];
      const item = { ...(items[index] || {}) };

      // compute qty for steel or as-is
      if (this.context.isSteelTraders()) {
        const t = Number(item.thickness || 0);
        const w = Number(item.width || 0);
        const l = Number(item.length || 0);
        const p = Number(item.pieces || 0);
        item.qty = (t * w * l * p * 7.85) / 1000000000;
      } else {
        item.qty = Number(item.qty || 0);
      }

      item.costPerPiece = Number(item.costPerPiece || 0);
      item.quoteAmount = Number((item.qty * item.costPerPiece).toFixed(2));

      // clear flags and put back
      item.__isEditing = false;
      item.__isNew = false;
      items[index] = item;
      orderDetail.quoteItems = items;
      return { orderDetail, editingRowBackup: null };
    });
  };

  // Delete row (immutable)
  deleteRow = (index) => {
    this.setState((prev) => {
      const orderDetail = { ...prev.orderDetail };
      const items = [...(orderDetail.quoteItems || [])];
      if (index < 0 || index >= items.length) return null;
      items.splice(index, 1);
      // reassign seqNo if you want
      orderDetail.quoteItems = items.map((it, i) => ({ ...it, seqNo: i + 1 }));
      return { orderDetail };
    });
  };

  isNew = () => !this.state.orderDetail?.id;

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  SaveOrder = () => {
    this.ShowLoadSpinner();
    const isNew = this.isNew();
    const tmporder = { ...this.state.orderDetail };

    if (this.state.quoteStatusNew !== "")
      tmporder.quoteStatus = Number(this.state.quoteStatusNew);

    if (isNew) {
      const ok =
        (tmporder.customerName || "").trim().length > 0 &&
        (tmporder.contactNumber || "").trim().length > 0 &&
        tmporder.storeId;
      if (!ok) {
        this.HideLoadSpinner();
        Swal.fire({
          title: "Info",
          text: "Customer name & contact are required.",
          timer: 1800,
        });
        return;
      }
      tmporder.quoteStatus = 1;
      tmporder.paymentStatus = 2;
    }

    const url = isNew
      ? process.env.REACT_APP_API + "Quotation/CreateQuotationRequest"
      : process.env.REACT_APP_API + "Quotation/UpdateQuationRequest/";
    const method = isNew ? "POST" : "PUT";

    fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmporder),
    })
      .then(async (res) => {
        if (!res.ok) {
          this.HideLoadSpinner();
          throw new Error("save failed");
        }
        const payload = isNew ? await res.json() : null;

        return Swal.fire({
          title: "Status",
          text: isNew ? `Created ${payload.quoteNumber}` : "Saved Successfully",
          timer: 1200,
        });
      })
      .then(() => {
        // ✅ tell parent to refresh lists & counters
        this.props.onSaved && this.props.onSaved();
        // close modal
        this.props.onHide();
      })
      .catch((err) => {
        alert("Failed: " + err.message);
      })
      .finally(() => {
        // always hide spinner, success or error
        this.HideLoadSpinner();
      });
  };

  isPaidFull = () => {
    const totals = this.GrandTotalOfQuotation();
    const totPaid = (this.state.orderDetail.quotePayments || []).reduce(
      (a, v) => a + Number(v.amount || 0),
      0,
    );

    if (
      totals.grandTotal !== 0 &&
      Math.round(totals.grandTotal) === Math.round(totPaid)
    )
      return true;
    return false;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.SaveOrder();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "quoteStatusNew":
        if (value == 4 || value == 6) {
          //fullypaid or startproduct
          if (this.isPaidFull() == false) {
            Swal.fire({
              title: "Information",
              text: "It looks like the Total Quotation amount yet to be paid!",
              timer: 3000,
            });
            return;
          }
        }
        if (value == 3) {
          // Quotation Complete and Send Email
          const totals = this.GrandTotalOfQuotation();
          if (totals.grandTotal == 0 || this.QuoteCompleted() == false) {
            Swal.fire({
              title: "Information",
              text: "It looks like quotation is not complete yet",
              timer: 3000,
            });
            return;
          }
        }
        this.setState({ quoteStatusNew: value });
        break;

      case "quotationTotalAmount":
        this.state.orderDetail.quotationTotalAmount = value;
        break;

      case "amountReceived":
        this.state.orderDetail.amountReceived = value;
        break;

      case "paymentStatus":
        if (value == 2 || value == 3)
          this.state.orderDetail.paymentStatus = value;
        else if (value == 1 && this.isPaidFull() == true)
          this.state.orderDetail.paymentStatus = value;
        else
          Swal.fire({
            title: "Information",
            text: "It looks like the Total Quotation amount yet to be paid!",
            timer: 3000,
          });
        break;

      case "requestSeverityType":
      case "assignedTo":
      case "notes":
        this.state.orderDetail[name] = value;
        break;

      case "quoteRemarks":
        this.state.orderDetail[name] = value;
        break;

      // allow editing header fields in CREATE mode only
      case "customerName":
      case "contactNumber":
      case "emailId":
      case "purposeOfProcurement":
      case "preferredLanguage":
      case "deliveryTimeline":
      case "address":
      case "landmark":
      case "city":
      case "state":
      case "country":
      case "pincode":
      case "taxNo":
        this.state.orderDetail[name] = value;
        break;

      // NEW: charges & tax
      case "loadingCharges":
        this.state.orderDetail.loadingCharges = Number(value || 0);
        break;
      case "transportationCharges":
        this.state.orderDetail.transportationCharges = Number(value || 0);
        break;
      case "taxPercentage":
        this.state.orderDetail.taxPercentage = Number(value || 0);
        break;

      default:
        // if some other field, try to set it safely
        this.state.orderDetail[name] = value;
        break;
    }
    this.setState({ orderDetail: this.state.orderDetail });
  };

  // replace handleChange so editing inputs update state immutably and update quoteAmount live
  handleChange = (e, index) => {
    const { name, value } = e.target;
    this.setState((prev) => {
      const orderDetail = { ...prev.orderDetail };
      const items = [...(orderDetail.quoteItems || [])];
      items[index] = { ...(items[index] || {}), [name]: value };

      // live compute quoteAmount for visible feedback (don't round final here)
      const item = items[index];
      if (this.context.isSteelTraders()) {
        const t = Number(item.thickness || 0);
        const w = Number(item.width || 0);
        const l = Number(item.length || 0);
        const p = Number(item.pieces || 0);
        item.qty = (t * w * l * p * 7.85) / 1000000000;
      } else {
        item.qty = Number(item.qty || 0);
      }
      item.costPerPiece = Number(item.costPerPiece || 0);
      item.quoteAmount = Number((item.qty * item.costPerPiece).toFixed(2));
      items[index] = item;

      orderDetail.quoteItems = items;
      return { orderDetail };
    });
  };

  OnDeleteRequirement(e, i) {
    const list = [...this.state.orderDetail.quoteItems];
    list.splice(i, 1);
    this.state.orderDetail.quoteItems = list;
    this.setState({ orderDetail: this.state.orderDetail });
  }

  OnDeletePayment = (e, i) => {
    const list = [
      ...this.state.orderDetail.quotePayments.sort((a, b) =>
        a.created > b.created ? 1 : -1,
      ),
    ];
    list.splice(i, 1);
    this.state.orderDetail.quotePayments = list;
    this.setState({ orderDetail: this.state.orderDetail });
  };

  OnPaymentModalClose = () => {
    this.setState({ ShowPaymentModal: false });
  };

  AddNewRequirement = (str) => {
    var list = this.state.orderDetail.quoteItems;
    list.push(str);
    this.state.orderDetail.quoteItems = list;
    this.setState({ orderDetail: this.state.orderDetail });
  };

  AddNewPayment = (str) => {
    var list = this.state.orderDetail.quotePayments;
    list.push(str);
    this.state.orderDetail.quotePayments = list;
    this.setState({ orderDetail: this.state.orderDetail });
  };

  OnNewRequirementModalClose = () => {
    this.setState({ ShowNewRequirementModal: false });
  };

  computeItemPieceAndMTTotals() {
    const items = this.state.orderDetail.quoteItems || [];
    const totals = items.reduce(
      (acc, it) => {
        if (this.context.isSteelTraders()) {
          const p = Number(it.pieces || 0);
          const m = Number(it.qty || 0); // qty holds computed MT for steel
          acc.pieces += p;
          acc.mt += m;
        } else {
          const q = Number(it.qty || 0);
          acc.pieces += q; // interpret "pieces" as total qty for non-steel
          // mt remains 0 for non-steel
        }
        return acc;
      },
      { pieces: 0, mt: 0 },
    );

    // Normalize decimals: pieces integer, mt 3 decimals
    return {
      pieces: Number(totals.pieces),
      mt: Number(totals.mt.toFixed(3)),
    };
  }

  // Unified GrandTotalOfQuotation: returns object { subtotal, loading, transportation, tax, grandTotal }
  GrandTotalOfQuotation() {
    const items = this.state.orderDetail.quoteItems || [];
    const subtotal = items.reduce(
      (acc, v) => acc + Number(v?.quoteAmount || 0),
      0,
    );

    const loading = Number(this.state.orderDetail.loadingCharges || 0);
    const transportation = Number(
      this.state.orderDetail.transportationCharges || 0,
    );
    const taxPercent = Number(this.context.taxDetails.taxPercentage ?? 18);

    // Tax applied on (subtotal + loading + transportation)
    const taxableBase = subtotal + loading + transportation;
    const tax = (taxableBase * taxPercent) / 100;

    const grandTotal = subtotal + loading + transportation + tax;

    return {
      subtotal: Number(subtotal.toFixed(2)),
      loading: Number(loading.toFixed(2)),
      transportation: Number(transportation.toFixed(2)),
      tax: Number(tax.toFixed(2)),
      grandTotal: Number(grandTotal.toFixed(2)),
    };
  }

  QuoteCompleted = () => {
    var result = (this.state.orderDetail.quoteItems || []).filter(
      (f) => Number(f.costPerPiece || 0) === 0,
    );
    if (result.length > 0) return false;
    return true;
  };

  componentDidMount = () => {
    const items = this.state.orderDetail?.quoteItems || [];
    this.state.orderDetail.quoteItems = [...items].sort((a, b) =>
      a.seqNo > b.seqNo ? 1 : -1,
    );
    this.state.orderDetail.loadingCharges = Number(
      this.state.orderDetail.loadingCharges || 0,
    );
    this.state.orderDetail.transportationCharges = Number(
      this.state.orderDetail.transportationCharges || 0,
    );
    this.state.orderDetail.taxPercentage = Number(
      this.context.taxDetails.taxPercentage ?? 18,
    );
    this.setState({ orderDetail: this.state.orderDetail });
  };

  render() {
    const isNew = !this.state.orderDetail?.id;
    const itemTotals = this.computeItemPieceAndMTTotals();
    const totals = this.GrandTotalOfQuotation();
    const fmt = (v) =>
      Number(v || 0).toLocaleString(
        this.context.storeSettings?.defaultLocale || "en-US",
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          style: "currency",
          currency:
            (this.context.storeSettings &&
              this.context.storeSettings.defaultCurrency) ||
            "INR",
        },
      );

    return (
      <div className="container">
        <Modal
          {...this.props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          size="xl"
          fullscreen="sm-down" // <-- full screen on small devices
          backdrop="static"
          keyboard={false}
          dialogClassName="quotation"
          show={true}
          onHide={this.props.onHide}
        >
          <Form
            onSubmit={this.handleSubmit}
            style={{ fontFamily: "Verdana", fontSize: "14px" }}
          >
            <Modal.Header closeButton className="quotation-modal-header">
              <Modal.Title className="d-flex align-items-center gap-3 w-100">
                <div>
                  <div className="h4 mb-0">
                    {isNew ? "New Quotation Order" : "Edit Quotation Order"}
                  </div>
                </div>
                <div style={{ marginLeft: "auto" }}>
                  <span
                    className={`badge-status ${
                      (this.state.orderDetail?.quoteStatus === 1 &&
                        "badge-open") ||
                      (this.state.orderDetail?.quoteStatus === 2 &&
                        "badge-follow") ||
                      (this.state.orderDetail?.quoteStatus === 3 &&
                        "badge-closed") ||
                      (this.state.orderDetail?.quoteStatus === 4 &&
                        "badge-cancel") ||
                      "badge-open"
                    }`}
                  >
                    {this.state.orderDetail?.quoteStatus == 1
                      ? "Open"
                      : this.state.orderDetail?.quoteStatus == 2
                        ? "Following-Up"
                        : this.state.orderDetail?.quoteStatus == 3
                          ? "Closed"
                          : this.state.orderDetail?.quoteStatus == 4
                            ? "Cancelled"
                            : "Open"}
                  </span>
                </div>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-3">
              {/* QUOTATION STATUS CARD */}
              <div className="card section mb-3 quotation-card">
                <div className="card-body">
                  <h5 className="mb-3">Quotation Status</h5>
                  <Row className="g-2 align-items-center">
                    <Col xs={12} md={6} lg={2}>
                      <FloatingLabel label="Current Status">
                        <Form.Select
                          size="lg"
                          disabled
                          value={this.state.orderDetail.quoteStatus || 1}
                          onChange={this.handleInputChange}
                        >
                          {(this.props.quotationTypes || []).map((m) => (
                            <option value={m.id} key={m.id}>
                              {m.statusName}
                            </option>
                          ))}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>

                    <Col xs={12} md={6} lg={2}>
                      <FloatingLabel label="Next Status">
                        <Form.Select
                          type="text"
                          name="quoteStatusNew"
                          size="lg"
                          value={this.state.quoteStatusNew}
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          <option value=""></option>
                          {/* keep same logic for options depending on CurrentState */}
                          {this.props.CurrentState == "NewRequest" ? (
                            <>
                              <option value={2}>
                                Start Requirement Review
                              </option>
                              <option value={10}>Cancel Quotation</option>
                            </>
                          ) : this.props.CurrentState == "Quotation" ? (
                            <>
                              {this.context.store.businessTypeId ==
                              this.context.BusinessTypes.STEELTRADERS ? (
                                <option value={9}>
                                  Quotation Complete & Send Email
                                </option>
                              ) : (
                                <>
                                  <option value={3}>
                                    Quotation Complete & Send Email
                                  </option>
                                  <option value={10}>Cancel Quotation</option>
                                </>
                              )}
                            </>
                          ) : this.props.CurrentState == "Payment" ? (
                            <>
                              <option value={4}>FullPaymentReceived</option>
                              <option value={5}>PartialPaymentReceived</option>
                              <option value={6}>Start Produce/Making</option>
                              <option value={10}>
                                Cancel Quotation Request
                              </option>
                            </>
                          ) : this.props.CurrentState == "Produce" ? (
                            <>
                              <option value={7}>
                                Produce Complete & Ready To Ship
                              </option>
                              <option value={10}>
                                Refunded Amount & Cancel the Order
                              </option>
                            </>
                          ) : this.props.CurrentState == "Ship" ? (
                            <>
                              <option value={8}>
                                Fully Paid And Sent For Delivery
                              </option>
                              <option value={10}>
                                Refunded Amount & Cancel the Order
                              </option>
                            </>
                          ) : this.props.CurrentState == "Delivery" ? (
                            <>
                              <option value={9}>Delivery and Closed</option>
                            </>
                          ) : null}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>

                    <Col xs={12} md={6} lg={2}>
                      <FloatingLabel label="Payment Status">
                        <Form.Select
                          name="paymentStatus"
                          value={this.state.orderDetail.paymentStatus || 2}
                          onChange={this.handleInputChange}
                        >
                          <option value={1}>Paid</option>
                          <option value={2}>UnPaid</option>
                          <option value={3}>PartiallyPaid</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>

                    <Col xs={12} md={6} lg={2}>
                      <FloatingLabel label="Severity">
                        <Form.Select
                          required
                          name="requestSeverityType"
                          value={
                            this.state.orderDetail.requestSeverityType || ""
                          }
                          onChange={this.handleInputChange}
                        >
                          <option value=""></option>
                          <option value={1}>HOT</option>
                          <option value={2}>WARM</option>
                          <option value={3}>COLD</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>

                    <Col xs={12} md={6} lg={2}>
                      <FloatingLabel label="Assign To">
                        <Form.Select
                          size="lg"
                          name="assignedTo"
                          value={this.state.orderDetail.assignedTo || ""}
                          onChange={this.handleInputChange}
                        >
                          <option value=""></option>
                          {(this.props.users || []).map((d) =>
                            d.emailId === "productsupport" ? null : (
                              <option value={d.id} key={d.id}>
                                {d.emailId}
                              </option>
                            ),
                          )}
                        </Form.Select>
                      </FloatingLabel>
                    </Col>

                    <Col xs={12} md={6} lg={2} className="text-center">
                      {this.state.orderDetail.quoteStatus != 1 ? (
                        <Button
                          variant="outline-primary"
                          onClick={this.printInvoice}
                          title="Open invoice in a new window and print"
                        >
                          <i className="fa fa-print" /> Print/Download PDF
                        </Button>
                      ) : null}
                    </Col>

                    <Col xs={12} className="mt-2">
                      <Form.Group>
                        <Form.Label>Remarks</Form.Label>
                        <Form.Control
                          as="textarea"
                          name="notes"
                          rows={3}
                          maxLength={1999}
                          value={this.state.orderDetail.notes || ""}
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              {/* CUSTOMER DETAILS CARD */}
              <div className="card section mb-3 quotation-card">
                <div className="card-body">
                  <h5 className="mb-3">Customer Details</h5>
                  <Row className="g-2">
                    <Col xs={12} md={6} lg={3}>
                      <FloatingLabel label="Quotation Number" className="mb-2">
                        <Form.Control
                          type="text"
                          disabled
                          value={this.state.orderDetail.quoteNumber || ""}
                        />
                      </FloatingLabel>
                    </Col>

                    <Col xs={12} md={6} lg={3}>
                      <FloatingLabel label="Request Created" className="mb-2">
                        <Form.Control
                          type="text"
                          disabled
                          value={
                            this.state.orderDetail.created
                              ? this.context.GetInDateFormat(
                                  new Date(this.state.orderDetail.created),
                                )
                              : ""
                          }
                        />
                      </FloatingLabel>
                    </Col>

                    <Col xs={12} md={6} lg={3}>
                      <FloatingLabel label="Customer Name *" className="mb-2">
                        <Form.Control
                          type="text"
                          name="customerName"
                          value={this.state.orderDetail.customerName || ""}
                          onChange={this.handleInputChange}
                          required
                        />
                      </FloatingLabel>
                    </Col>

                    <Col xs={12} md={6} lg={3}>
                      <FloatingLabel label="Contact Number" className="mb-2">
                        <Form.Control
                          type="text"
                          name="contactNumber"
                          maxLength={10}
                          value={this.state.orderDetail.contactNumber || ""}
                          onChange={this.handleInputChange}
                        />
                      </FloatingLabel>
                    </Col>

                    <Col xs={12} md={6} lg={4}>
                      <FloatingLabel label="Email id" className="mb-2">
                        <Form.Control
                          type="email"
                          name="emailId"
                          value={this.state.orderDetail.emailId || ""}
                          onChange={this.handleInputChange}
                        />
                      </FloatingLabel>
                    </Col>

                    <Col xs={12} md={6} lg={4}>
                      <FloatingLabel label="Purpose" className="mb-2">
                        <Form.Control
                          type="text"
                          name="purposeOfProcurement"
                          value={
                            this.state.orderDetail.purposeOfProcurement || ""
                          }
                          onChange={this.handleInputChange}
                        />
                      </FloatingLabel>
                    </Col>

                    <Col xs={12} md={6} lg={4}>
                      <FloatingLabel
                        label="Preferred Language"
                        className="mb-2"
                      >
                        <Form.Control
                          type="text"
                          name="preferredLanguage"
                          value={this.state.orderDetail.preferredLanguage || ""}
                          onChange={this.handleInputChange}
                        />
                      </FloatingLabel>
                    </Col>

                    {/* Address fields: stack nicely on small screens */}
                    {!isNew ? (
                      <Col xs={12}>
                        <FloatingLabel label="Address" className="mb-2">
                          <Form.Control
                            type="text"
                            disabled
                            value={
                              (this.state.orderDetail.address || "") +
                              (this.state.orderDetail.landmark
                                ? ", " + this.state.orderDetail.landmark
                                : "") +
                              (this.state.orderDetail.city
                                ? ", " + this.state.orderDetail.city
                                : "") +
                              (this.state.orderDetail.state
                                ? ", " + this.state.orderDetail.state
                                : "") +
                              (this.state.orderDetail.country
                                ? ", " + this.state.orderDetail.country
                                : "") +
                              (this.state.orderDetail.pincode
                                ? ", " + this.state.orderDetail.pincode
                                : "")
                            }
                          />
                        </FloatingLabel>
                      </Col>
                    ) : (
                      <>
                        <Col xs={12} md={6} lg={4}>
                          <FloatingLabel label="Address" className="mb-2">
                            <Form.Control
                              type="text"
                              name="address"
                              value={this.state.orderDetail.address || ""}
                              onChange={this.handleInputChange}
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={6} md={3} lg={2}>
                          <FloatingLabel label="Landmark" className="mb-2">
                            <Form.Control
                              type="text"
                              name="landmark"
                              value={this.state.orderDetail.landmark || ""}
                              onChange={this.handleInputChange}
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={6} md={3} lg={2}>
                          <FloatingLabel label="City" className="mb-2">
                            <Form.Control
                              type="text"
                              name="city"
                              value={this.state.orderDetail.city || ""}
                              onChange={this.handleInputChange}
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={6} md={3} lg={2}>
                          <FloatingLabel label="State" className="mb-2">
                            <Form.Control
                              type="text"
                              name="state"
                              value={this.state.orderDetail.state || ""}
                              onChange={this.handleInputChange}
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={6} md={3} lg={2}>
                          <FloatingLabel label="Country" className="mb-2">
                            <Form.Control
                              type="text"
                              name="country"
                              value={this.state.orderDetail.country || ""}
                              onChange={this.handleInputChange}
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={6} md={3} lg={2}>
                          <FloatingLabel label="Pincode" className="mb-2">
                            <Form.Control
                              type="text"
                              name="pincode"
                              value={this.state.orderDetail.pincode || ""}
                              onChange={this.handleInputChange}
                            />
                          </FloatingLabel>
                        </Col>
                      </>
                    )}

                    <Col xs={12} md={3} className="d-flex align-items-center">
                      {this.state.orderDetail.attachmentFileName ? (
                        <div className="p-2 border CornersRoundedSmall bg-white w-100">
                          <div className="small text-muted">Attachment</div>
                          <div className="fw-bold">
                            {this.state.orderDetail.attachmentFileName}
                          </div>
                          <a
                            href={
                              this.context.store.storageBlobUrl +
                              this.context.store.storageBlobContainerName +
                              "/attachments/" +
                              this.state.orderDetail.attachmentFileName +
                              this.context.store.storageSasToken
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="small d-block mt-1 text-decoration-none"
                          >
                            View
                          </a>
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                </div>
              </div>

              {/* REQUIREMENTS & QUOTATION (Items) */}
              <div className="card section mb-3 quotation-card">
                <div className="card-body">
                  <Row>
                    <Col>
                      <h5>Requirements & Quotation</h5>
                    </Col>
                    <Col className="text-end">
                      <Button
                        variant="outline-primary"
                        onClick={() =>
                          this.setState({ showProductModal: true })
                        }
                      >
                        + Add
                      </Button>
                    </Col>
                  </Row>

                  {/* Desktop: keep the original table on md+ */}
                  <div className="d-none d-md-block">
                    <div className="table-responsive mt-3">
                      <Table className="mt-3">
                        <thead className="bg-light small">
                          {this.context.isSteelTraders() ? (
                            <tr>
                              <th>#</th>
                              <th>Product</th>
                              <th>Thick</th>
                              <th>Width</th>
                              <th>Length</th>
                              <th>Pieces</th>
                              <th>MT</th>
                              <th>Cost/MT</th>
                              <th>Total</th>
                              <th></th>
                            </tr>
                          ) : this.context.storeSettings
                              .isQuotationSupported ? (
                            <tr>
                              <th>#</th>
                              <th>Category</th>
                              <th>Product/Item</th>
                              <th>Detail Requirement</th>
                              <th>Qty/Wt</th>
                              <th>Cost/Unit</th>
                              <th>Total(approx)</th>
                              <th></th>
                            </tr>
                          ) : (
                            <tr>
                              <th>#</th>
                              <th>Product/Item</th>
                              <th>Detail Requirement</th>
                              <th>Qty</th>
                              <th>Cost/Unit</th>
                              <th>Total(approx)</th>
                              <th></th>
                            </tr>
                          )}
                        </thead>

                        <tbody>
                          {this.state.orderDetail.quoteItems.map((order, i) => (
                            <tr key={i}>
                              {/* reuse existing desktop row markup exactly as you already have */}
                              {this.context.isSteelTraders() ? (
                                <>
                                  <td>{i + 1}</td>
                                  <td>
                                    <Form.Control
                                      type="text"
                                      name="productName"
                                      value={order.productName}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="thickness"
                                      value={order.thickness}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="width"
                                      value={order.width}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="length"
                                      value={order.length}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="pieces"
                                      value={order.pieces}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="qty"
                                      disabled
                                      value={(
                                        (order.thickness *
                                          order.width *
                                          order.length *
                                          order.pieces *
                                          7.85) /
                                        1000000000
                                      ).toFixed(2)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="costPerPiece"
                                      value={order.costPerPiece}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    {(
                                      ((order.thickness *
                                        order.width *
                                        order.length *
                                        order.pieces *
                                        7.85) /
                                        1000000000) *
                                      order.costPerPiece
                                    ).toFixed(0)}
                                  </td>
                                  <td>
                                    <OverlayTrigger
                                      overlay={<Tooltip>Delete</Tooltip>}
                                    >
                                      <Button
                                        size="sm"
                                        variant="outline-danger"
                                        onClick={(e) => {
                                          if (
                                            window.confirm(
                                              "Are you sure you want to Delete ?",
                                            )
                                          )
                                            this.OnDeleteRequirement(e, i);
                                        }}
                                      >
                                        X
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                </>
                              ) : this.context.storeSettings
                                  .isQuotationSupported ? (
                                <>
                                  <td>{i + 1}</td>
                                  <td>{order.categoryName}</td>
                                  <td>{order.productName}</td>
                                  <td>
                                    <Form.Control
                                      as="textarea"
                                      rows={2}
                                      name="detailedRequirement"
                                      value={order.detailedRequirement}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="qty"
                                      value={order.qty}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="costPerPiece"
                                      value={order.costPerPiece}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="text"
                                      readOnly
                                      value={order.quoteAmount}
                                    />
                                  </td>
                                  <td>
                                    <OverlayTrigger
                                      overlay={<Tooltip>Delete</Tooltip>}
                                    >
                                      <Button
                                        size="sm"
                                        variant="outline-danger"
                                        onClick={(e) => {
                                          if (
                                            window.confirm(
                                              "Are you sure you want to Delete ?",
                                            )
                                          )
                                            this.OnDeleteRequirement(e, i);
                                        }}
                                      >
                                        X
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td>{i + 1}</td>
                                  <td>
                                    <Form.Control
                                      type="text"
                                      name="productName"
                                      value={order.productName}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      as="textarea"
                                      rows={2}
                                      name="detailedRequirement"
                                      value={order.detailedRequirement}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="qty"
                                      value={order.qty}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      name="costPerPiece"
                                      value={order.costPerPiece}
                                      onChange={(e) => {
                                        this.handleChange(e, i);
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <Form.Control
                                      type="text"
                                      readOnly
                                      value={order.quoteAmount}
                                    />
                                  </td>
                                  <td>
                                    <OverlayTrigger
                                      overlay={<Tooltip>Delete</Tooltip>}
                                    >
                                      <Button
                                        size="sm"
                                        variant="outline-danger"
                                        onClick={(e) => {
                                          if (
                                            window.confirm(
                                              "Are you sure you want to Delete ?",
                                            )
                                          )
                                            this.OnDeleteRequirement(e, i);
                                        }}
                                      >
                                        X
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                </>
                              )}
                            </tr>
                          ))}

                          {/* totals and charges rows (unchanged) */}
                          <tr className="fw-bold bg-light">
                            <td colSpan={8} className="text-end">
                              {this.context.isSteelTraders() ? (
                                <>
                                  Total Pieces:&nbsp;
                                  {itemTotals.pieces.toLocaleString(
                                    this.context.storeSettings?.defaultLocale ||
                                      "en-US",
                                  )}{" "}
                                  &nbsp;&nbsp;|&nbsp;&nbsp; Total MT:&nbsp;
                                  {itemTotals.mt.toLocaleString(
                                    this.context.storeSettings?.defaultLocale ||
                                      "en-US",
                                    {
                                      minimumFractionDigits: 3,
                                      maximumFractionDigits: 3,
                                    },
                                  )}
                                </>
                              ) : (
                                <>
                                  Total Qty:&nbsp;
                                  {itemTotals.pieces.toLocaleString(
                                    this.context.storeSettings?.defaultLocale ||
                                      "en-US",
                                  )}
                                </>
                              )}
                            </td>
                            <td colSpan={2} className="text-end">
                              Subtotal:&nbsp;{fmt(totals.subtotal)}
                            </td>
                          </tr>

                          <tr className="bg-light">
                            <td colSpan={8} className="text-end">
                              Loading Charges :
                            </td>
                            <td colSpan={2}>
                              <Form.Control
                                type="number"
                                step="0.01"
                                name="loadingCharges"
                                value={
                                  this.state.orderDetail.loadingCharges || 0
                                }
                                onChange={this.handleInputChange}
                                className="form-control form-control-sm"
                              />
                            </td>
                          </tr>

                          <tr className="bg-light">
                            <td colSpan={8} className="text-end">
                              Transportation Charges :
                            </td>
                            <td colSpan={2}>
                              <Form.Control
                                type="number"
                                step="0.01"
                                name="transportationCharges"
                                value={
                                  this.state.orderDetail
                                    .transportationCharges || 0
                                }
                                onChange={this.handleInputChange}
                                className="form-control form-control-sm"
                              />
                            </td>
                          </tr>

                          <tr className="fw-bold bg-light">
                            <td colSpan={8} className="text-end">
                              Tax ({this.context.taxDetails.taxPercentage}
                              %):
                            </td>
                            <td colSpan={2}>{fmt(totals.tax)}</td>
                          </tr>

                          <tr className="fw-bold bg-light">
                            <td colSpan={8} className="text-end">
                              Grand Total :
                            </td>
                            <td colSpan={2}>{fmt(totals.grandTotal)}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>

                  {/* Mobile: stacked card list for small screens */}
                  {/* Mobile: stacked card list for small screens (complete branches) */}
                  <div className="d-block d-md-none">
                    <div className="mt-3">
                      {this.state.orderDetail.quoteItems.map((order, i) => (
                        <div className="card mb-2" key={i}>
                          <div className="card-body p-2">
                            <div className="d-flex justify-content-between align-items-start">
                              <div>
                                <div className="fw-bold">
                                  #{i + 1} {order.productName || ""}
                                </div>

                                {this.context.isSteelTraders() ? (
                                  <>
                                    <div className="small">
                                      Thick: {order.thickness || "-"}
                                    </div>
                                    <div className="small">
                                      W: {order.width || "-"} L:{" "}
                                      {order.length || "-"}
                                    </div>
                                    <div className="small">
                                      Pieces: {order.pieces || "-"}
                                    </div>
                                  </>
                                ) : this.context.storeSettings
                                    .isQuotationSupported ? (
                                  <>
                                    <div className="small">
                                      Category: {order.categoryName || "-"}
                                    </div>
                                    <div className="small text-truncate">
                                      Req: {order.detailedRequirement || "-"}
                                    </div>
                                  </>
                                ) : (
                                  /* FALLBACK when quotationSupported is false (previously missed) */
                                  <>
                                    <div className="small text-truncate">
                                      Req: {order.detailedRequirement || "-"}
                                    </div>
                                    <div className="small">
                                      Qty: {order.qty || "-"}
                                    </div>
                                  </>
                                )}
                              </div>

                              <div className="text-end">
                                <div className="small text-muted">Total</div>
                                <div className="fw-bold">
                                  {this.context.isSteelTraders()
                                    ? (
                                        ((Number(order.thickness || 0) *
                                          Number(order.width || 0) *
                                          Number(order.length || 0) *
                                          Number(order.pieces || 0) *
                                          7.85) /
                                          1000000000) *
                                        Number(order.costPerPiece || 0)
                                      ).toFixed(0)
                                    : Number(order.quoteAmount || 0).toFixed(2)}
                                </div>
                              </div>
                            </div>

                            {/* editable small form row */}
                            <Row className="mt-2 gx-2">
                              {this.context.isSteelTraders() ? (
                                <>
                                  <Col xs={6}>
                                    <Form.Control
                                      size="sm"
                                      placeholder="Thick"
                                      type="number"
                                      name="thickness"
                                      value={order.thickness}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>
                                  <Col xs={6}>
                                    <Form.Control
                                      size="sm"
                                      placeholder="Width"
                                      type="number"
                                      name="width"
                                      value={order.width}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>
                                  <Col xs={6} className="mt-2">
                                    <Form.Control
                                      size="sm"
                                      placeholder="Length"
                                      type="number"
                                      name="length"
                                      value={order.length}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>
                                  <Col xs={6} className="mt-2">
                                    <Form.Control
                                      size="sm"
                                      placeholder="Pieces"
                                      type="number"
                                      name="pieces"
                                      value={order.pieces}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>
                                  <Col xs={6} className="mt-2">
                                    <Form.Control
                                      size="sm"
                                      placeholder="Cost/MT"
                                      type="number"
                                      name="costPerPiece"
                                      value={order.costPerPiece}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>
                                </>
                              ) : this.context.storeSettings
                                  .isQuotationSupported ? (
                                /* quotation-supported mobile inputs */
                                <>
                                  <Col xs={12}>
                                    <Form.Control
                                      size="sm"
                                      placeholder="Category"
                                      type="text"
                                      name="categoryName"
                                      value={order.categoryName}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>

                                  <Col xs={12} className="mt-2">
                                    <Form.Control
                                      size="sm"
                                      placeholder="Product/Item"
                                      type="text"
                                      name="productName"
                                      value={order.productName}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>

                                  <Col xs={12} className="mt-2">
                                    <Form.Control
                                      size="sm"
                                      as="textarea"
                                      rows={2}
                                      placeholder="Detail Requirement"
                                      name="detailedRequirement"
                                      value={order.detailedRequirement}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>

                                  <Col xs={6} className="mt-2">
                                    <Form.Control
                                      size="sm"
                                      placeholder="Qty/Wt"
                                      type="number"
                                      name="qty"
                                      value={order.qty}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>

                                  <Col xs={6} className="mt-2">
                                    <Form.Control
                                      size="sm"
                                      placeholder="Cost/Unit"
                                      type="number"
                                      name="costPerPiece"
                                      value={order.costPerPiece}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>
                                </>
                              ) : (
                                /* fallback mobile inputs when quotationSupported == false */
                                <>
                                  <Col xs={12}>
                                    <Form.Control
                                      size="sm"
                                      placeholder="Product/Item"
                                      type="text"
                                      name="productName"
                                      value={order.productName}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>

                                  <Col xs={12} className="mt-2">
                                    <Form.Control
                                      size="sm"
                                      as="textarea"
                                      rows={2}
                                      placeholder="Detail Requirement"
                                      name="detailedRequirement"
                                      value={order.detailedRequirement}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>

                                  <Col xs={6} className="mt-2">
                                    <Form.Control
                                      size="sm"
                                      placeholder="Qty"
                                      type="number"
                                      name="qty"
                                      value={order.qty}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>

                                  <Col xs={6} className="mt-2">
                                    <Form.Control
                                      size="sm"
                                      placeholder="Cost/Unit"
                                      type="number"
                                      name="costPerPiece"
                                      value={order.costPerPiece}
                                      onChange={(e) => this.handleChange(e, i)}
                                    />
                                  </Col>
                                </>
                              )}

                              <Col xs={12} className="mt-2 text-end">
                                <OverlayTrigger
                                  overlay={<Tooltip>Delete</Tooltip>}
                                >
                                  <Button
                                    size="sm"
                                    variant="outline-danger"
                                    onClick={(e) => {
                                      if (
                                        window.confirm(
                                          "Are you sure you want to Delete ?",
                                        )
                                      )
                                        this.OnDeleteRequirement(e, i);
                                    }}
                                  >
                                    Delete
                                  </Button>
                                </OverlayTrigger>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      ))}

                      {/* Mobile totals & charges (same values, stacked layout) */}
                      <div className="card mt-2">
                        <div className="card-body p-2">
                          <div className="mb-2">
                            {this.context.isSteelTraders() ? (
                              <>
                                <div>Total Pieces: {itemTotals.pieces}</div>
                                <div>Total MT: {itemTotals.mt}</div>
                              </>
                            ) : (
                              <div>Total Qty: {itemTotals.pieces}</div>
                            )}
                          </div>

                          <div className="mb-2 d-flex justify-content-between">
                            <div>Subtotal:</div>
                            <div>{fmt(totals.subtotal)}</div>
                          </div>

                          <div className="mb-2 d-flex justify-content-between">
                            <div>Loading Charges:</div>
                            <div style={{ width: "45%" }}>
                              <Form.Control
                                size="sm"
                                type="number"
                                step="0.01"
                                name="loadingCharges"
                                value={
                                  this.state.orderDetail.loadingCharges || 0
                                }
                                onChange={this.handleInputChange}
                                className="form-control form-control-sm"
                              />
                            </div>
                          </div>

                          <div className="mb-2 d-flex justify-content-between">
                            <div>Transportation Charges:</div>
                            <div style={{ width: "45%" }}>
                              <Form.Control
                                size="sm"
                                type="number"
                                step="0.01"
                                name="transportationCharges"
                                value={
                                  this.state.orderDetail
                                    .transportationCharges || 0
                                }
                                onChange={this.handleInputChange}
                                className="form-control form-control-sm"
                              />
                            </div>
                          </div>

                          <div className="mb-2 d-flex justify-content-between">
                            <div>
                              Tax ({this.context.taxDetails.taxPercentage}
                              %):
                            </div>
                            <div>{fmt(totals.tax)}</div>
                          </div>

                          <div className="fw-bold d-flex justify-content-between">
                            <div>Grand Total:</div>
                            <div>{fmt(totals.grandTotal)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Row>
                    <Col md={12} className="mt-2">
                      <Form.Group>
                        <Form.Label>Notes, Terms & Condition:</Form.Label>
                        <Form.Control
                          as="textarea"
                          name="quoteRemarks"
                          rows={8}
                          maxLength={1999}
                          readOnly
                          value={
                            this.context.storeSettings
                              .quotationTermsAndConditions
                          }
                          // value={this.state.orderDetail.quoteRemarks || ""}
                          // onChange={this.handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </div>

              {/* Payments card (keeps table-responsive) */}
              {this.context.isSteelTraders() ||
              this.context.storeSettings.isQuotationSupported ==
                false ? null : (
                <div className="card section mb-3 quotation-card">
                  <div className="card-body">
                    <Row>
                      <Col>
                        <h5>Payment History</h5>
                      </Col>
                      <Col className="text-end">
                        <Button
                          onClick={() =>
                            this.setState({ ShowPaymentModal: true })
                          }
                        >
                          + Add
                        </Button>
                      </Col>
                    </Row>

                    <div className="table-responsive mt-3">
                      <Table className="mt-3 small">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Received</th>
                            <th>TransactionID</th>
                            <th>Amount</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {(this.state.orderDetail.quotePayments || [])
                            .sort((a, b) => (a.created > b.created ? 1 : -1))
                            .map((payment, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>
                                  {payment.created
                                    ? this.context.GetInDateFormat(
                                        new Date(payment.created),
                                      )
                                    : ""}
                                </td>
                                <td>{payment.paymentTransactionId}</td>
                                <td>
                                  {Number(payment.amount || 0).toLocaleString(
                                    this.context.storeSettings.defaultLocale,
                                    {
                                      style: "currency",
                                      currency:
                                        this.context.storeSettings
                                          .defaultCurrency,
                                    },
                                  )}
                                </td>
                                <td>
                                  {payment.paymentMethod == 2 && (
                                    <OverlayTrigger
                                      overlay={<Tooltip>Delete</Tooltip>}
                                    >
                                      <Button
                                        className="mx-1 text-danger border-0"
                                        style={{ background: "transparent" }}
                                        onClick={() => {
                                          if (
                                            window.confirm(
                                              "Are you sure you want to Delete ?",
                                            )
                                          )
                                            this.OnDeletePayment(null, i);
                                        }}
                                      >
                                        <i className="fa fa-trash" />
                                      </Button>
                                    </OverlayTrigger>
                                  )}
                                </td>
                              </tr>
                            ))}

                          <tr>
                            <td colSpan={3} className="text-end">
                              <strong>Total Paid:</strong>
                            </td>
                            <td colSpan={2}>
                              <strong>
                                {(this.state.orderDetail.quotePayments || [])
                                  .reduce(
                                    (a, v) => a + Number(v.amount || 0),
                                    0,
                                  )
                                  .toLocaleString(
                                    this.context.storeSettings.defaultLocale,
                                    {
                                      style: "currency",
                                      currency:
                                        this.context.storeSettings
                                          .defaultCurrency,
                                    },
                                  )}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              )}
            </Modal.Body>

            {/* Sticky footer with actions */}
            <div className="quotation sticky-footer d-flex justify-content-end gap-2 p-2">
              <Button
                variant="outline-secondary"
                className="btn-secondary-soft"
                onClick={this.props.onHide}
              >
                Close
              </Button>
              <Button type="submit" className="btn-primary-gradient">
                {isNew ? "Create" : "Save"}
              </Button>
            </div>
          </Form>
          {this.state.showProductModal && (
            <ProductSelectionModal
              show={true}
              onHide={() => this.setState({ showProductModal: false })}
              onSelect={this.addProductToQuotation}
            />
          )}
        </Modal>

        {/* Payment / Requirement modals */}
        {this.state.ShowPaymentModal && (
          <AddPaymentModal
            orderDetail={this.state.orderDetail}
            OnClose={() => this.setState({ ShowPaymentModal: false })}
            AddNewPayment={this.AddNewPayment}
          />
        )}
        {this.state.ShowNewRequirementModal && (
          <AddNewRequirementsModal
            orderDetail={this.state.orderDetail}
            AddNewRequirement={this.AddNewRequirement}
            OnClose={() => this.setState({ ShowNewRequirementModal: false })}
          />
        )}
      </div>
    );
  }
}

export class AddNewRequirementsModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      productName: "",
      costPerPiece: 0,
      qty: 1,
    };
  }

  // helper to safely parse number inputs
  parseNumber = (v) => {
    if (v === "" || v === null || v === undefined) return 0;
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const productName = (this.state.productName || "").trim();
    const costPerPiece = this.parseNumber(this.state.costPerPiece);
    const qty = this.parseNumber(this.state.qty);

    if (productName !== "" && costPerPiece > 0 && qty > 0) {
      const str = {
        quoteId: this.props.orderDetail?.id ?? null, // safe fallback
        productName,
        costPerPiece,
        qty,
        quoteAmount: Number((costPerPiece * qty).toFixed(2)),
        seqNo: (this.props.orderDetail?.quoteItems?.length || 0) + 1,
      };

      if (typeof this.props.AddNewRequirement === "function") {
        this.props.AddNewRequirement(str);
      }
      if (typeof this.props.OnClose === "function") {
        this.props.OnClose();
      }
    } else {
      Swal.fire({
        title: "Warning",
        text: "Please enter valid Product, Cost (>0) and Qty (>0).",
        confirmButtonText: "Ok",
      });
    }
  };

  render() {
    const cost = this.parseNumber(this.state.costPerPiece);
    const qty = this.parseNumber(this.state.qty);
    const total = Number((cost * qty).toFixed(2));

    return (
      <div className="container">
        <Modal
          {...this.props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          size="md"
          fullscreen="sm-down" // full screen on small devices
          backdrop="static"
          keyboard={false}
          show={true}
        >
          <Form
            style={{ fontFamily: "Verdana", fontSize: "14px" }}
            onSubmit={this.handleSubmit}
          >
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                Add Product or Other Charges
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="show-grid">
              <Row className="g-2">
                <Col xs={12} md={7}>
                  <Form.Group className="mb-2">
                    <Form.Label>Product / Item</Form.Label>
                    <Form.Control
                      type="text"
                      name="productName"
                      maxLength={63}
                      value={this.state.productName}
                      required
                      onChange={(e) =>
                        this.setState({ productName: e.target.value })
                      }
                      placeholder="Name of product or charge"
                    />
                  </Form.Group>
                </Col>

                <Col xs={6} md={2}>
                  <Form.Group className="mb-2">
                    <Form.Label>Cost</Form.Label>
                    <Form.Control
                      type="number"
                      name="costPerPiece"
                      min="0"
                      step="0.01"
                      required
                      value={this.state.costPerPiece}
                      onChange={(e) =>
                        this.setState({
                          costPerPiece:
                            e.target.value === ""
                              ? ""
                              : this.parseNumber(e.target.value),
                        })
                      }
                    />
                  </Form.Group>
                </Col>

                <Col xs={6} md={2}>
                  <Form.Group className="mb-2">
                    <Form.Label>Qty</Form.Label>
                    <Form.Control
                      type="number"
                      name="qty"
                      min="1"
                      step="1"
                      required
                      value={this.state.qty}
                      onChange={(e) =>
                        this.setState({
                          qty:
                            e.target.value === ""
                              ? ""
                              : this.parseNumber(e.target.value),
                        })
                      }
                    />
                  </Form.Group>
                </Col>

                <Col xs={12} md={1} className="d-flex align-items-end">
                  <div className="w-100 text-md-end">
                    <div className="small text-muted">Total</div>
                    <div className="fw-bold">{total}</div>
                  </div>
                </Col>

                <Col xs={12}>
                  <Form.Text className="text-muted">
                    Tip: values update live. On mobile the dialog will go
                    fullscreen for easier entry.
                  </Form.Text>
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" type="submit" size="lg">
                  Save
                </Button>
              </Form.Group>
              <Button
                variant="danger"
                size="lg"
                onClick={() => this.props.OnClose && this.props.OnClose()}
              >
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export class AddPaymentModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      created: new Date(),
      transactionID: "",
      amount: 0,
    };
  }

  handleSubmit = (e) => {
    if (this.state.transactionID.length != "" && this.state.amount > 0) {
      var tCreated =
        new Date(this.state.created).getMonth() +
        1 +
        "/" +
        new Date(this.state.created).getDate() +
        "/" +
        new Date(this.state.created).getFullYear();

      var str = {
        created: tCreated,
        quoteId: this.props.orderDetail.id, // will be set after create+save
        paymentTransactionId: this.state.transactionID,
        amount: this.state.amount,
        paymentMethod: 2, // offline
      };
      this.props.AddNewPayment(str);
      this.props.OnClose();
    } else
      Swal.fire({
        title: "Warning",
        text: "Invalid Inputs",
        confirmButtonText: "Ok",
      });
  };

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          size="SM"
          backdrop="static"
          keyboard={false}
          show={true}
        >
          <Form style={{ fontFamily: "Verdana", fontSize: "14px" }}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                Add Payment
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Form.Group className="mb-3">
                <Form.Label>Date</Form.Label>
                <DatePicker
                  format="dd-MMM-yy"
                  onChange={(e) => this.setState({ created: e })}
                  value={this.state.created}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Transaction Ref</Form.Label>
                <Form.Control
                  type="text"
                  name="transactionID"
                  maxLength={63}
                  value={this.state.transactionID}
                  onChange={(e) =>
                    this.setState({ transactionID: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  name="amount"
                  value={this.state.amount}
                  onChange={(e) => this.setState({ amount: e.target.value })}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" onClick={this.handleSubmit} size="lg">
                  Save
                </Button>
              </Form.Group>
              <Button variant="danger" size="lg" onClick={this.props.OnClose}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export class QuotationDashboardModal extends Component {
  static contextType = CartContext;
  state = { loading: false, error: null, summary: null };

  componentDidMount() {
    this.loadSummary();
  }

  loadSummary = async () => {
    this.setState({ loading: true, error: null });
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}Quotation/GetSummary/${this.context.storeId}`,
      );
      const json = await res.json();
      this.setState({ summary: json, loading: false });
    } catch (e) {
      this.setState({ error: e.message, loading: false });
    }
  };

  buildStatusPie = (s) => ({
    labels: [
      "New",
      "Quotation",
      "Payment",
      "Produce",
      "Ship",
      "Delivery",
      "History",
    ],
    datasets: [
      { data: [1, 2, 3, 6, 7, 8, 9].map((k) => s.statusCounts?.[k] || 0) },
    ],
  });

  buildPaymentPie = (s) => ({
    labels: ["Paid", "Unpaid", "Partially Paid"],
    datasets: [{ data: [1, 2, 3].map((k) => s.paymentCounts?.[k] || 0) }],
  });

  buildLast7Line = (s) => ({
    labels: (s.last7Days || []).map((d) => d.date),
    datasets: [
      {
        label: "Quotes",
        data: s.last7Days.map((d) => d.count),
        borderColor: "blue",
      },
      {
        label: "AmountReceived",
        data: s.last7Days.map((d) => d.received),
        borderColor: "green",
      },
    ],
  });

  render() {
    const { show, onHide } = this.props;
    const { summary, loading, error } = this.state;

    return (
      <Modal show={show} onHide={onHide} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Quotation Analytics Dashboard</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && <LoadSpinner open />}
          {error && <div className="alert alert-danger">{error}</div>}
          {summary && (
            <>
              <Row>
                <Col>
                  <h5>Total Quotes: {summary.totalQuotes}</h5>
                  <p>Total Received: {summary.totalReceived}</p>
                </Col>
                <Col>
                  <p>Today Quotes: {summary.todayQuotes}</p>
                  <p>Today Received: {summary.todayReceived}</p>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Pie data={this.buildStatusPie(summary)} />
                </Col>
                <Col md={6}>
                  <Pie data={this.buildPaymentPie(summary)} />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Line data={this.buildLast7Line(summary)} />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <h6>Recent Quotes</h6>
                  <Table size="sm" striped>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Quote</th>
                        <th>Customer</th>
                        <th>Created</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(summary.recentQuotes || []).map((q, i) => (
                        <tr key={q.id}>
                          <td>{i + 1}</td>
                          <td>{q.quoteNumber}</td>
                          <td>{q.customerName}</td>
                          <td>{new Date(q.created).toLocaleString()}</td>
                          <td>{q.amountReceived}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onHide}>Close</Button>
          <Button onClick={this.loadSummary}>Refresh</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

class ProductSelectionModal extends React.Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = { search: "" };
  }

  render() {
    const search = this.state.search.toLowerCase();

    const products = (this.context.prods || [])
      .filter((p) => !p.hideMe)
      .filter(
        (p) =>
          p.name?.toLowerCase().includes(search) ||
          p.sku?.toLowerCase().includes(search),
      );

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Product</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Control
            type="search"
            placeholder="Search by Name / SKU..."
            className="mb-3"
            onChange={(e) => this.setState({ search: e.target.value })}
          />

          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            <Table hover>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>SKU</th>
                  <th>Stock</th>
                  <th>MRP</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {products.map((p) => (
                  <tr key={p.id}>
                    <td>{p.name}</td>
                    <td>{p.sku}</td>
                    <td>
                      <span
                        style={{
                          color: p.inStockQty <= 5 ? "red" : "green",
                        }}
                      >
                        {p.inStockQty || 0}
                      </span>
                    </td>
                    <td>₹ {p.mrp || 0}</td>
                    <td>
                      <Button size="sm" onClick={() => this.props.onSelect(p)}>
                        Select
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
